import { createContext } from 'use-context-selector'

import { KitSize } from 'components/uiKit/KitTypes'

import type { IFormContext } from '../types'

const FormContext = createContext<IFormContext<object>>({
  defaultValues: {},
  inheritValues: {},
  initialValues: {},
  values: {},
  metas: {},
  formConfig: {},

  registerFormField: () => console.error('Form context is not exist'),
  unregisterFormField: () => console.error('Form context is not exist'),
  onChangeValue: () => console.error('Form context is not exist'),
  setValues: () => console.error('Form context is not exist'),
  onChangeMeta: () => console.error('Form context is not exist'),
  setMetas: () => console.error('Form context is not exist'),
  submit: () => console.error('Form context is not exist'),
  resetFields: () => console.error('Form context is not exist'),
  onFieldFocus: () => console.error('Form context is not exist'),
  onFieldBlur: () => console.error('Form context is not exist'),

  layout: 'vertical',
  size: KitSize.M,
  submitting: false,
  disabled: false,
  isValid: true,
  isDirty: false,
  isTouched: false,
})

export default FormContext
